const ALERT_TYPES = {
  RADIO_OPTIONS: `RADIO_OPTIONS`,
  INFO: `INFO`,
  CONFIRM: `CONFIRM`,
  ERROR: `ERROR`,
  BUTTONS: `BUTTONS`,
  OPTIONS: `OPTIONS`,
  CUSTOM: `CUSTOM`,
};

export default ALERT_TYPES;
